import {
  pathogenicVeryStrongColor,
  pathogenicStrongColor,
  pathogenicModerateColor,
  pathogenicSupportingColor,
  benignVeryStrongColor,
  benignStrongColor,
  benignModerateColor,
  benignSupportingColor,
} from "../../../../../common/helpers/colors";

export const pathogenicColors = {
  "Stand Alone": pathogenicVeryStrongColor,
  "Very Strong": pathogenicVeryStrongColor,
  Strong: pathogenicStrongColor,
  Moderate: pathogenicModerateColor,
  Supporting: pathogenicSupportingColor,
};

export const benignColors = {
  "Stand Alone": benignVeryStrongColor,
  "Very Strong": benignVeryStrongColor,
  Strong: benignStrongColor,
  Moderate: benignModerateColor,
  Supporting: benignSupportingColor,
};

export const effectStrings = {
  functionProbablyNotAffected: "Probably does not affect function",
  functionProbablyAffected: "Probably affects function",
  functionNotAffected: "Does not affect function",
  functionAffected: "Affects function",
  unknown: "Unknown",
};

export const pathogenicitiesSortingArray = [
  "pathogenic",
  "likely pathogenic",
  "uncertain significance",
  "uncertain",
  "vus",
  "likely benign",
  "benign",
];
